import useDialog from "../../utils/useDialog";
import React, { useEffect, useState, useRef } from "react";

const Modal = ({ children, viewClass, rootClass = "", isHide, onClose, label }) => {
  const dialogRef = useRef(null);
  useDialog(dialogRef, onClose);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setOpen(true), 10);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`modal-root ${rootClass} ${open ? "modal-open" : ""}`}
      style={{ background: isHide ? "transparent" : "" }}
    >
      <div ref={dialogRef} role="dialog" aria-modal="true" aria-label={label} tabIndex={-1} className={`tt-modal ${viewClass}`}>{children}</div>
    </div>
  );
};

export default Modal;
